import { render, staticRenderFns } from "./agv-basic-article-info.vue?vue&type=template&id=6e7d25a6&scoped=true&lang=pug&"
import script from "./agv-basic-article-info.vue?vue&type=script&lang=js&"
export * from "./agv-basic-article-info.vue?vue&type=script&lang=js&"
import style0 from "./agv-basic-article-info.vue?vue&type=style&index=0&id=6e7d25a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7d25a6",
  null
  
)

export default component.exports